const API_BASE_URL =
  process.env.REACT_APP_API_URL || `${window.location.origin}/api`;

const postJson = async (path, payload) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Request failed.');
  }

  return data;
};

export const registerUser = async ({ name, email, password }) => {
  return postJson('/register', { name, email, password });
};

export const loginUser = async ({ email, password }) => {
  return postJson('/login', { email, password });
};
